import React from "react";

export default function FaqCounsellor() {
    return (
        <div className="">
            <h1 className="md:text-5xl text-3xl font-semibold text-center my-8">
                <span className="text-blue-500">FAQs</span> of <span className="text-orange-400">counsellors</span>
            </h1>
            <Counsellor
                question="Why should the counsellor join our platform?"
                answer="There are further financial and non-financial advantages to serving as a mentor, which have already been thoroughly described above. Additionally, there is a potential of placement."
            />
            <Counsellor
                question="What are the benefits a counsellor will get if they join Career Hikers?"
                answer="Any counsellor who joins our Career Hikers platform will receive both financial and non-financial rewards. In addition to these advantages, the career counsellors will receive a letter of recommendation from Career Hikers, which will aid them in their placements cell. Additionally, by serving as a counsellor, you may influence the destiny of numerous pupils."
            />
            <Counsellor
                question="What are the non-financial benefits?"
                answer="Among the non-financial advantages are:
                •	Improvement of people management skills (PMS).
                •	Improvement in persuasion abilities.
                •	Improvement of leadership abilities.
                •	Improved counselling abilities.
                •	Opportunity for pre-placement with Career Hikers.
                •	Can be used as an opportunity for an internship.
                •	Improvement in the psychological knowledge of students.
                •	Improvement of creative abilities.
                "
            />
            <Counsellor
                question="What is the process of becoming the counsellor in our platform?"
                answer="The simple process of becoming the counsellor in our platform is to go to the page become a counsellor and fill the form or you can share your CV to the following mail id- info@careerhikers.com/hr@careerhikers.com Once your resume is shortlisted you will receive the call from our team."
            />
            <Counsellor
                question="Does this experience will count in their colleges/resume?"
                answer="Yes, according to the provisions of the internship programme, their institutions will count this experience. The finest feature of this internship/job is that you may offer the time from 6 p.m. to 11 p.m., which is after your college hours/ working hours."
            />
            <Counsellor
                question="Do all session payments are count?"
                answer="Yes, being as the counsellor you will receive the amount for the every session either that student is paid or not."
            />
            <Counsellor
                question="How many rounds are there in the interview?"
                answer="Generally, there are three rounds-
                1.	Basic Introduction Round
                2.	Manager’s Round
                3.	Final Round
                "
            />
            <Counsellor
                question="What are the future plans for the counsellor?"
                answer="Apart from Monetary and Non- Monetary Benefits a counsellor can secure the future also in the Career Hikers. Also, we have a big plan for all of our counsellors’ community which will always make our mentors feel special."
            />
            <Counsellor
                question="What is the goal of this ABHAY program in the terms of counsellor?"
                answer="The goal of this ABHAY program is to create the new revolution in the market not only assisting the students but guiding them in the way of choosing their career, letting them about the future opportunities, future technologies etc"
            />
            <Counsellor
                question="Who can join as the counsellor in the Career Hikers platform?"
                answer="Anyone can apply to be a Career counsellor on the Career Hikers platform, including those enrolled in IIT, NEET, IIIT, AIIMS, DU, MBA, CA, Government Colleges of Medical and Engineering, and working professionals, those preparing for UPSC and other government examinations and industry experts."
            />
            <Counsellor
                question="What distinguishes Career Hikers counsellors from counsellors who do not work with Career Hikers?"
                answer="At Career Hikers, we think that both the counsellors and the student can change one other's lives. Because they will guide all of the students as well as receive additional financial and non-financial rewards, the mentors who are affiliated with us will always feel good about themselves."
            />
        </div>

    )
}

function Counsellor(props) {
    return (
        <div className="collapse border-2 mx-4 md:mx-16">
            <input type="checkbox" />
            <div className="collapse-title text-lg md:text-xl font-medium">
                {props.question}
            </div>
            <div className="collapse-content md:text-base text-sm">
                <p>{props.answer}</p>
            </div>
        </div>
    )
}